export default function Values() {
    const values = ["Quality", "Integrity", "Innovation", "Sustainability", "Customer Focus", "Teamwork"];
    return (
        <section id="values" className="values-section">
            <h2 className="section-title">Company Values</h2>
            <div className="values-wrapper">
                <div className="values-track">
                    {values.concat(values).map((v, i) => (  // duplicate for seamless loop
                        <div key={i} className="value-card">{v}</div>
                    ))}
                </div>
            </div>
        </section>
    );
}
